<div class="form --one-line">

  <app-autocomplete-form-field
    class="form__field__country"
    [controlName]="'extension'"
    [selections]="countries"
    [form]="formGroup"
    [formModel]="formModel[controlName]"
    [validators]="this.validators"
    [options]="{
      label: 'accountInfos.countryCode' | transloco
    }"
  />

  <mat-form-field>
    <mat-label>{{ 'accountInfos.number' | transloco }}</mat-label>

    <input
      type="tel"
      matInput
      [formControl]="formGroup.controls.digits"
      [required]="validators.includes('required')"
      (onWheel)="$event?.preventDefault()"
      (click)="$event?.stopPropagation()"
      >
    @if (formGroup.controls.digits.value) {
      <button type="button" mat-icon-button matSuffix (click)="cleanField('digits')">
        <mat-icon>close</mat-icon>
      </button>
    }

    @if (formGroup.controls.digits) {
      <mat-error>{{ 'formErrors.' + Objectkeys(formGroup.controls.digits)?.[0] | transloco }}</mat-error>
    }

  </mat-form-field>

</div>

@if (formGroup.controls?.digits?.touched && !!formGroup.errors) {
  <mat-error class="fs-12">{{ 'formErrors.' + Objectkeys(formGroup.errors)?.[0] | transloco }}</mat-error>
}
